import API from "@/API";
import dataTableCreator from "@/store/creators/dataTable";

const SET_USER = "SET_USER";

const state = {
  user: null,
  headers: [
    { text: "Status", value: "status" },
    { text: "Link", value: "link", sortable: false },
    { text: "Tipo", value: "type", sortable: false },
    { text: "Criado em", value: "created_at" },
    { text: "Cliente", value: "customer", sortable: false },
    { text: "Profissional", value: "professional", sortable: false },
    { text: "Data", value: "starts_at", sortable: false },
    { text: "Duração", value: "duration", sortable: false },
    { text: "Cidade", value: "city", sortable: false },
    { text: "Valor", value: "price" },
    { text: "Taxa", value: "fee" },
    { text: "Total", value: "total" }
  ]
};

const actions = {
  setUser({ state, commit, dispatch }, user) {
    if (state.user === user) return;
    commit("SET_USER", user);
    dispatch("resetDataTable");
  },

  async getItems({ dispatch }) {
    dispatch("startLoader");

    try {
      let results = await API.Orders.getList();
      dispatch("setTotalItems", results.totalItems);
      dispatch("setItems", results.data);
    } catch (e) {
      dispatch("clearItems");
      dispatch("stopLoader");
      throw e;
    }

    dispatch("stopLoader");
  }
};

const mutations = {
  [SET_USER](state, user) {
    state.user = user;
  }
};

export default {
  namespaced: true,
  state: { ...dataTableCreator.state, ...state },
  actions: { ...dataTableCreator.actions, ...actions },
  mutations: { ...dataTableCreator.mutations, ...mutations },
  getters: dataTableCreator.getters
};



// WEBPACK FOOTER //
// ./src/store/modules/orders/list.js